import React, { Component } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Menu.style.css";
import { activeLanguage } from "../../../config";
import { getLanguage } from "../../../languages";
import {
  Dashboard,
  AccountBox,
  // AccountCircle,
  Settings,
  // ManageAccounts,
  Cloud,
  Telegram,
  // SupervisedUserCircle,
  // RecentActors,
  // GroupAdd,
  // SettingsSystemDaydream,
  Summarize,
  Fitbit,
  Sell,
  StackedLineChart,
  TrendingDown,
  Groups,
  Receipt,
  LocalAtm,
  Archive,
  AutoFixHigh,
  MonitorHeart,
  CandlestickChart,
  Event,
  Toc,
  AddToQueue,
  AutoMode,
  Circle,
  AccessTime,
  CloudSync,
  AccountBalanceWallet,
  Grading,
  AddLinkRounded,
  ReportOutlined,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";
import { Typography, Badge, IconButton, Tooltip } from "@mui/material";
import { apiCountJobList } from "../../Service/api";
const stylesListComent = {
  inline: {
    display: "inline",
  },
};

const badgeStyle = {
  "& .MuiBadge-badge": {
    right: `${-10}px`,
  },
};

class Menu extends Component {
  constructor(props) {
    super(props);

    // console.log("props menus: ", props);

    this.language = getLanguage(activeLanguage, "Menu");

    this.state = {
      role: 0,
      menus: [],
      loginInfo: props.loginInfo,
      community: props.community,
      currentParent: 0,
      currentChild: -1,
      count: 0,
      countJobList: 0,
      invisible: false,
    };
  }

  componentDidMount = () => {
    this.selectRole(this.props.loginInfo, this.props.community);

    this.loadInitialCount();
    // this.countJoblist();
    this.intervalNotif = setInterval(() => {
      this.loadInitialCount();
    }, 3000);
    // this.intervalCount = setInterval(() => {
    //   this.countJoblist();
    // }, 60000);
  };

  componentDidUpdate(prevProps) {
    if (this.props.loginInfo !== prevProps.loginInfo) {
      this.selectRole(this.props.loginInfo, this.state.community);
    }
  }

  loadInitialCount = () => {
    const counts = localStorage.getItem("count");
    const notif = JSON.parse(counts);
    if (notif) {
      // console.log("interval count: ", notif);
      this.setState({ countJobList: notif });
    }
  };

  countJoblist = () => {
    apiCountJobList()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          const count = data.count;
          localStorage.setItem("count", JSON.stringify(count));
          this.setState({
            countJobList: count,
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  selectRole = (loginInfo, community) => {
    this.setState({ role: loginInfo.logintype });
    this.selectType(loginInfo.logintype, community);
  };

  selectType = (role, community) => {
    if (role === 1) {
      this.menuSuperAdmin(community);
    } else if (role === 2) {
      this.menuAgent(community);
    } else if (role === 3) {
      this.agentMember(community);
    } else if (role === 4) {
      this.menuMember(community);
    }
  };

  toogleSubMenu = (menu, idx) => {
    let menus = this.state.menus;

    menus[idx].openChild = !menus[idx].openChild;
    this.setState({ menus: menus });
  };

  menuSuperAdmin = (community) => {
    let tmpMenu = [];
    tmpMenu.push(
      {
        id: 0,
        label: "Dashboard",
        to: "/panel/dashboard",
        openChild: false,
        childs: [],
      },
      // {
      //   id: 1,
      //   label: "Trade Chart",
      //   to: "/panel/trade-chart",
      //   openChild: false,
      //   childs: [],
      // },
      {
        id: 2,
        label: "VPS",
        to: "/panel/vps",
        openChild: false,
        childs: [],
      },
      {
        id: 3,
        label: "Accounts",
        to: "/panel/accounts",
        openChild: false,
        childs: [],
      },
      {
        id: 4,
        label: "Archived",
        to: "/panel/archived",
        openChild: false,
        childs: [],
      },
      {
        id: 5,
        label: "Reporting",
        to: "",
        openChild: false,
        childs: [
          {
            id: 51,
            label: "Audit Profit",
            to: "/panel/audit-profit",
          },
        ],
      },

      // {
      //   id: 5,
      //   label: "Adjustment",
      //   to: "/panel/adjustment",
      //   openChild: false,
      //   childs: [],
      // },
      // {
      //   id: 17,
      //   label: "Summary",
      //   to: "/panel/summary",
      //   openChild: false,
      //   childs: [],
      // },
      {
        id: 6,
        label: "Daily",
        to: "",
        openChild: false,
        childs: [
          // {
          //   id: 60,
          //   label: "Daily Balance",
          //   to: "/panel/daily-balance",
          // },
          {
            id: 61,
            label: "Daily Profit",
            to: "/panel/daily-profit",
          },
          {
            id: 62,
            label: "Daily Withdrawal",
            to: "/panel/daily-withdrawal",
          },
          {
            id: 63,
            label: "Daily Deposit",
            to: "/panel/daily-deposit",
          },
        ],
      },

      {
        id: 7,
        label: "Agent",
        to: "/panel/agent",
        openChild: false,
        childs: [],
      },
      {
        id: 19,
        label: "Ownership",
        to: "/panel/ownership",
        openChild: false,
        childs: [],
      },
      {
        id: 8,
        label: "Performance",
        to: "/panel/performance",
        openChild: false,
        childs: [],
      },
      {
        id: 9,
        label: "Invoice",
        to: "",
        openChild: false,
        childs: [
          {
            id: 91,
            label: "Agent",
            to: "/panel/invoice/agent",
          },
          // {
          //   id: 92,
          //   label: "Member",
          //   to: "/panel/invoice/member",
          // },
        ],
      },
      {
        id: 10,
        label: "Rate",
        to: "/panel/rate",
        openChild: false,
        childs: [],
      },
      {
        id: 11,
        label: "Master Slave",
        to: "",
        openChild: false,
        childs: [
          {
            id: 111,
            label: "Setting",
            to: "/panel/master-slave-setting",
          },
          {
            id: 112,
            label: "List",
            to: "/panel/master-slave-list",
          },
        ],
      },
      {
        id: 12,
        label: "VPS Migration",
        to: "/panel/vps-migration",
        openChild: false,
        childs: [],
      },
      {
        id: 13,
        label: "Job",
        to: "",
        openChild: false,
        childs: [
          {
            id: 131,
            label: "List",
            to: "/panel/job-list",
          },
          {
            id: 132,
            label: "Log",
            to: "/panel/job-log",
          },
        ],
      },
      {
        id: 14,
        label: "Automation",
        to: "",
        openChild: false,
        childs: [
          {
            id: 141,
            label: "Log",
            to: "/panel/automation-log",
          },
          {
            id: 142,
            label: "Issues",
            to: "/panel/automation-issues",
          },
        ],
      },
      {
        id: 18,
        label: "Checker",
        to: "",
        openChild: false,
        childs: [
          {
            id: 181,
            label: "Blacklist",
            to: "/panel/checker-blacklist",
          },
        ],
      },
      {
        id: 15,
        label: "Clients",
        to: "/panel/clients",
        openChild: false,
        childs: [],
      },
      {
        id: 16,
        label: "Settings",
        to: "",
        openChild: false,
        childs: [
          {
            id: 161,
            label: "User",
            to: "/panel/user",
          },
          // {
          //   id: 162,
          //   label: "WhatsApp",
          //   to: "/panel/whatsapp",
          // },
        ],
      },
      // {
      //   id: 20,
      //   label: "Billing",
      //   to: "",
      //   openChild: false,
      //   childs: [
      //     {
      //       id: 201,
      //       label: "User Billing Settings",
      //       to: "/panel/billing/user-settings",
      //     },
      //     {
      //       id: 202,
      //       label: "Daily Fee Summary",
      //       to: "/panel/billing/daily-fee-summary",
      //     },
      //     {
      //       id: 203,
      //       label: "Credit Ledger",
      //       to: "/panel/billing/credit-ledger",
      //     },
      //     {
      //       id: 204,
      //       label: "Credit Balance",
      //       to: "/panel/billing/credit-balance",
      //     },
      //   ],
      // },
    );

    this.setState({
      menus: tmpMenu,
    });
  };

  menuAgent = (role) => {
    this.setState({
      menus: [
        {
          id: 0,
          label: this.language["dashboard"],
          to: "/panel/dashboard",
          openChild: false,
          childs: [],
        },
        {
          id: 1,
          label: "Accounts",
          to: "/panel/accounts",
          openChild: false,
          childs: [],
        },
        {
          id: 2,
          label: "Daily Balance",
          to: "/panel/daily-balance",
          openChild: false,
          childs: [],
        },
        {
          id: 3,
          label: "Daily Profit",
          to: "/panel/daily-profit",
          openChild: false,
          childs: [],
        },
        {
          id: 4,
          label: "Invoice",
          to: "/panel/invoice",
          openChild: false,
          childs: [],
        },
      ],
    });
  };

  agentMember = (role) => {
    this.setState({
      menus: [
        {
          id: 0,
          label: this.language["dashboard"],
          to: "/panel/dashboard",
          openChild: false,
          childs: [],
        },
        {
          id: 1,
          label: "Accounts",
          to: "/panel/accounts",
          openChild: false,
          childs: [],
        },
        {
          id: 2,
          label: "Daily Balance",
          to: "/panel/daily-balance",
          openChild: false,
          childs: [],
        },
        {
          id: 3,
          label: "Daily Profit",
          to: "/panel/daily-profit",
          openChild: false,
          childs: [],
        },
      ],
    });
  };

  menuMember = (role) => {
    this.setState({
      menus: [
        {
          id: 0,
          label: this.language["dashboard"],
          to: "/panel/dashboard",
          openChild: false,
          childs: [],
        },
        {
          id: 1,
          label: "Accounts",
          to: "/panel/accounts",
          openChild: false,
          childs: [],
        },
        {
          id: 2,
          label: "Daily Balance",
          to: "/panel/daily-balance",
          openChild: false,
          childs: [],
        },
        {
          id: 3,
          label: "Daily Profit",
          to: "/panel/daily-profit",
          openChild: false,
          childs: [],
        },
      ],
    });
  };

  updateParent = (id) => {
    this.setState({ currentParent: id, currentChild: -1 });
  };

  updateChild = (id) => {
    this.setState({ currentChild: id, currentParent: -1 });
  };

  iconBadge = () => {
    if (this.state.countJobList > 0) {
      return (
        <Badge color="primary" pill>
          {this.state.countJobList}
        </Badge>
      );
    }
  };

  renderforBadge = (submenu) => {
    if (submenu.label === "List") {
      return (
        <div
          className={`submenu ${
            this.state.currentChild === submenu.id ? "menu-active" : ""
          } `}
        >
          {this.renderSubMenuIcon(submenu.label)}{" "}
          <Badge
            badgeContent={this.state.countJobList}
            color="primary"
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={badgeStyle}
          >
            <Typography
              component="span"
              variant="subtitle2"
              style={
                (stylesListComent.inline,
                {
                  color: "#fff",
                  fontWeight: "bolder",
                })
              }
            >
              {submenu.label}
            </Typography>
          </Badge>
        </div>
      );
    } else {
      return (
        <div
          className={`submenu ${
            this.state.currentChild === submenu.id ? "menu-active" : ""
          } `}
        >
          {this.renderSubMenuIcon(submenu.label)}{" "}
          <Typography
            component="span"
            variant="subtitle2"
            style={
              (stylesListComent.inline,
              {
                color: "#fff",
                fontWeight: "bolder",
              })
            }
          >
            {submenu.label}
          </Typography>
        </div>
      );
    }
  };

  _renderSubMenu = (menu, idx) => {
    if (this.props.isCollapsed) {
      return "";
    }

    // console.log(menu);
    // this.loadCount();
    if (menu.openChild) {
      if (menu.label === "Job" && menu.childs[0].label === "List") {
        return (
          <div className="submenu-container">
            {menu.childs.map((submenu, i) => (
              <Link
                key={submenu.id}
                to={submenu.to}
                onClick={() => this.updateChild(submenu.id)}
                className={`link-custom`}
              >
                {this.renderforBadge(submenu)}
              </Link>
            ))}
          </div>
        );
      }
      return (
        <div className="submenu-container">
          {menu.childs.map((submenu, i) => (
            <Link
              key={submenu.id}
              to={submenu.to}
              onClick={() => this.updateChild(submenu.id)}
              className={`link-custom`}
            >
              <div
                className={`submenu ${
                  this.state.currentChild === submenu.id ? "menu-active" : ""
                } `}
              >
                {this.renderSubMenuIcon(submenu.label)}{" "}
                <Typography
                  component="span"
                  variant="subtitle2"
                  style={
                    (stylesListComent.inline,
                    {
                      color: "#fff",
                      fontWeight: "bolder",
                    })
                  }
                >
                  {submenu.label}
                </Typography>
              </div>
            </Link>
          ))}
        </div>
      );
    } else {
      return "";
    }
  };

  _renderChevronIcon = (menu) => {
    if (menu.openChild) {
      return <FontAwesomeIcon icon="chevron-down" />;
    } else {
      return <FontAwesomeIcon icon="chevron-left" />;
    }
  };

  _renderMenu = (menu, i) => {
    // console.log(menu);
    const isCollapsed = this.props.isCollapsed;
    const menuIcon = this.renderIconMenu(menu.label);
    const menuContent = (
      <>
        <span className="menu-icon">{menuIcon}</span>{" "}
        {menu.label === "Job" ? (
          <Badge
            badgeContent={this.state.countJobList}
            color="primary"
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            sx={badgeStyle}
          >
            <Typography
              className="menu-label"
              component="span"
              variant="subtitle2"
              style={
                (stylesListComent.inline,
                {
                  color: "#fff",
                  fontWeight: "bolder",
                })
              }
            >
              {menu.label}
            </Typography>
          </Badge>
        ) : (
          <Typography
            className="menu-label"
            component="span"
            variant="subtitle2"
            style={
              (stylesListComent.inline,
              {
                color: "#fff",
                fontWeight: "bolder",
              })
            }
          >
            {menu.label}
          </Typography>
        )}
      </>
    );
    const wrappedMenuContent = isCollapsed ? (
      <Tooltip title={menu.label} placement="right" arrow>
        <span className="menu-tooltip-content">{menuContent}</span>
      </Tooltip>
    ) : (
      menuContent
    );

    if (menu.to === "") {
      return (
        <div key={menu.id}>
          <div
            className="menu menu-parent"
            onClick={() =>
              isCollapsed
                ? this.props.onToggleMenuCollapsed()
                : this.toogleSubMenu(menu, i)
            }
          >
            {wrappedMenuContent}
            <div className="chevron-container">
              {this._renderChevronIcon(menu)}
            </div>
          </div>
          {this._renderSubMenu(menu, i)}
        </div>
      );
    } else {
      return (
        <Link
          key={menu.id}
          to={menu.to}
          onClick={() => this.updateParent(menu.id)}
          className={`link-custom`}
        >
          <div
            className={`menu ${
              this.state.currentParent === menu.id ? "menu-active" : ""
            } `}
          >
            {wrappedMenuContent}
            <div className="chevron-container"></div>
          </div>
        </Link>
      );
    }
  };

  renderIconMenu = (label) => {
    if (label === "Dashboard") {
      return <Dashboard />;
    } else if (label === "Accounts") {
      return <AccountBox />;
    } else if (label === "VPS") {
      return <Cloud />;
    } else if (label === "Settings") {
      return <Settings />;
    } else if (label === "Billing") {
      return <AccountBalanceWallet />;
    } else if (label === "Telegram") {
      return <Telegram />;
    } else if (label === "Daily Balance") {
      return <Summarize />;
    } else if (label === "Daily Profit") {
      return <StackedLineChart />;
    } else if (label === "Daily Withdrawal") {
      return <TrendingDown />;
    } else if (label === "Master Slave") {
      return <Fitbit />;
    } else if (label === "Agent") {
      return <Groups />;
    } else if (label === "Invoice") {
      return <Receipt />;
    } else if (label === "Buy & Sell") {
      return <Sell />;
    } else if (label === "Rate") {
      return <LocalAtm />;
    } else if (label === "Archived") {
      return <Archive />;
    } else if (label === "Adjustment") {
      return <AutoFixHigh />;
    } else if (label === "Performance") {
      return <MonitorHeart />;
    } else if (label === "Trade Chart") {
      return <CandlestickChart />;
    } else if (label === "Daily") {
      return <Event />;
    } else if (label === "Job") {
      return <Toc />;
    } else if (label === "Clients") {
      return <AddToQueue />;
    } else if (label === "Automation") {
      return <AutoMode />;
    } else if (label === "Trade Activity") {
      return <AccessTime />;
    } else if (label === "VPS Migration") {
      return <CloudSync />;
    } else if (label === "Summary") {
      return <AccountBalanceWallet />;
    } else if (label === "Checker") {
      return <Grading />;
    } else if (label === "Ownership") {
      return <AddLinkRounded />;
    } else if (label === "Reporting") {
      return <ReportOutlined />;
    }
  };

  // renderSubMenuIcon = (label) => {
  //   if (label === "Trading Account") {
  //     return <AccountCircle />;
  //   } else if (label === "User") {
  //     return <SupervisedUserCircle />;
  //   } else if (label === "API ID") {
  //     return <ManageAccounts />;
  //   } else if (label === "Accounts") {
  //     return <AccountBox />;
  //   } else if (label === "Group Account") {
  //     return <RecentActors />;
  //   } else if (label === "Group VPS") {
  //     return <SettingsSystemDaydream />;
  //   } else if (label === "Join Group") {
  //     return <GroupAdd />;
  //   }
  // };

  renderSubMenuIcon = (label) => {
    return <Circle fontSize="small" />;
  };

  render() {
    const isCollapsed = this.props.isCollapsed;

    return (
      <div
        className={`menu-container ${isCollapsed ? "menu-container-collapsed" : ""}`}
      >
        <div className="menu-toggle-container">
          <Tooltip
            title={isCollapsed ? "Open menu" : "Close menu"}
            placement="right"
            arrow
          >
            <IconButton
              className="menu-toggle-button"
              size="small"
              onClick={this.props.onToggleMenuCollapsed}
            >
              {isCollapsed ? (
                <KeyboardDoubleArrowRight fontSize="small" />
              ) : (
                <KeyboardDoubleArrowLeft fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        </div>
        {this.state.menus.map((menu, i) => this._renderMenu(menu, i))}
      </div>
    );
  }
}
export default Menu;
